import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CustomPlaceOrderService } from '@services/custom-place-order.service';
import { MiniCartComponentService } from '@spartacus/cart/base/components/mini-cart';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { EventService } from '@spartacus/core';
import { ICON_TYPE, LaunchDialogService } from '@spartacus/storefront';
import { startWith, take } from 'rxjs/operators';

@Component({
  selector: 'app-custom-cx-mini-cart',
  standalone: false,
  templateUrl: './custom-cx-mini-cart.component.html',
  styleUrls: ['./custom-cx-mini-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomCxMiniCartComponent {
  ghostData = {
    quantity: 0,
    total: 0,
    loaded: false,
  };

  iconTypes = ICON_TYPE;

  quantity$ = this.miniCartComponentService.getQuantity().pipe(startWith(this.ghostData.quantity));

  total$ = this.miniCartComponentService.getTotalPrice().pipe(startWith(this.ghostData.total));

  loaded$ = this.activeCartFacade.isStable().pipe(startWith(this.ghostData.loaded));

  openModal() {
    const dialog = this.launchDialogService.openDialog('MODAL_CART', undefined, undefined, undefined);

    if (dialog) {
      dialog.pipe(take(1)).subscribe();
    }
  }

  constructor(
    protected miniCartComponentService: MiniCartComponentService,
    protected launchDialogService: LaunchDialogService,
    protected eventService: EventService,
    private activeCartFacade: ActiveCartFacade
  ) {}
}
